const DATA = [
  // first slide
  [
    {
      key: 1,
      title: "cycle",
      btn_text: "Оставить заявку",
    },
    {
      key: 2,
      title: "healthy back",
      btn_text: "Оставить заявку",
    },
    {
      key: 3,
      title: "trx тренировка",
      btn_text: "Оставить заявку",
    },
    {
      key: 4,
      title: "Тренировки с персональным тренером",
      btn_text: "Оставить заявку",
    },
    {
      key: 5,
      title: "Yoga",
      title_color: "black",
      btn_text: "Оставить заявку",
    },
  ],
  // second slide
  [
    {
      key: 1,
      title: "pilates",
      btn_text: "Оставить заявку",
    },
    {
      key: 2,
      title: "hiit",
      title_color: "black",
      btn_text: "Оставить заявку",
    },
    {
      key: 3,
      title: "pump",
      title_color: "black",
      btn_text: "Оставить заявку",
    },
    {
      key: 4,
      title: "kickboxing",
      title_color: "black",
      btn_text: "Оставить заявку",
    },
    {
      key: 5,
      title: "stretching",
      btn_text: "Оставить заявку",
    },
  ],
  // third slide
  [
    {
      key: 1,
      title: "pilates roll",
      btn_text: "Оставить заявку",
    },
    {
      key: 2,
      title: "all body",
      btn_text: "Оставить заявку",
    },
    {
      key: 3,
      title: "teambeats",
      btn_text: "Оставить заявку",
    },
    {
      key: 4,
      title: "abl",
      btn_text: "Оставить заявку",
    },
    {
      key: 5,
      title: "Интервальные тренировки",
      btn_text: "Оставить заявку",
    },
  ],
];

export default DATA;
